// Each Workspace Settings section has its own address, so it can be linked
// to, bookmarked and reached with Back. `settingsTab` selects the section in
// AccountView (billing's are in billing.ts).
export const workspaceSettingsTabPaths = {
    workspace: '/workspace/settings',
    'icp-analysis': '/workspace/icp',
    branding: '/workspace/branding',
    'settings-general': '/workspace/settings/general',
    'settings-newmember': '/workspace/settings/member-defaults',
    'settings-contentnotif': '/workspace/settings/content',
    'settings-roles': '/workspace/settings/roles',
    emails: '/workspace/notifications',
}

// Website Analysis's tabs (AccountICPAnalysis): Customer Profiles is the
// section's own address, the others sit under it (`icpTab`).
export const icpTabPaths = {
    profiles: workspaceSettingsTabPaths['icp-analysis'],
    industries: `${workspaceSettingsTabPaths['icp-analysis']}/industries`,
    personas: `${workspaceSettingsTabPaths['icp-analysis']}/personas`,
    products: `${workspaceSettingsTabPaths['icp-analysis']}/products`,
    'use-cases': `${workspaceSettingsTabPaths['icp-analysis']}/use-cases`,
    'pain-points': `${workspaceSettingsTabPaths['icp-analysis']}/pain-points`,
    questions: `${workspaceSettingsTabPaths['icp-analysis']}/questions`,
    'qualifying-questions': `${workspaceSettingsTabPaths['icp-analysis']}/qualifying-questions`,
    objections: `${workspaceSettingsTabPaths['icp-analysis']}/objections`,
    topics: `${workspaceSettingsTabPaths['icp-analysis']}/topics`,
}

const workspaceSettingsNames = {
    'icp-analysis': 'Workspace Website Analysis',
    branding: 'Workspace Branding',
    'settings-general': 'Workspace Settings General',
    'settings-newmember': 'Workspace Settings Member Defaults',
    'settings-contentnotif': 'Workspace Settings Content Notifications',
    'settings-roles': 'Workspace Settings Roles',
    emails: 'Workspace Notifications',
}

export default [
    {
		// Where Slack's install screen sends you back (see views/account/slackConnect.ts)
		path: '/integrations/slack/callback',
		name: 'Slack Callback',
		component: () => import('@/views/account/SlackCallback.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'workspace-settings']],
			nav: 'workspace',
		}
	},
    {
		path: '/member/:id/:tab?/:subtab?/:idForAction?/:action?',
		name: 'Workspace Member',
		component: () => import('@/views/team/member/WorkspaceMember.vue'),
		props: true,
		meta: {
			layout: 'Default',
			abilities: [['view', 'workspace-schedules'], ['manage', 'my-profile'], ['manage', 'workspace-member-settings']],
			ownerIdParameter: 'id',
			nav: 'workspace',
		}
	},
	{
		path: '/workspace',
		name: 'Workspace',
		component: () => import('@/views/team/Workspace.vue'),
		meta: {
			layout: 'Default',
			abilities: [['view', 'workspace-members']],
			nav: 'workspace',
		}
	},
	{
		path: '/workspace/refresh',
		name: 'Workspace Refresh',
		component: () => import('@/views/team/Workspace.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'workspace-members']],
		}
	},
	{
		path: '/workspace/invited',
		name: 'Workspace Invite',
		component: () => import('@/views/team/WorkspaceInviteView.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'invitations']],
			nav: 'workspace',
		}
	},
    {
		path: workspaceSettingsTabPaths.workspace,
		name: 'Workspace Settings',
		component: () => import('@/views/account/AccountView.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'workspace-settings']],
			nav: 'workspace',
			settingsTab: 'workspace',
		}
	},
	...Object.entries(workspaceSettingsNames).map(([tab, name]) => ({
		path: workspaceSettingsTabPaths[tab],
		name,
		component: () => import('@/views/account/AccountView.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'workspace-settings']],
			nav: 'workspace',
			settingsTab: tab,
		},
	})),
	...[
		['industries', 'Workspace Website Analysis Industries'],
		['personas', 'Workspace Website Analysis Buyer Personas'],
		['products', 'Workspace Website Analysis Products'],
		['use-cases', 'Workspace Website Analysis Use Cases'],
		['pain-points', 'Workspace Website Analysis Pain Points'],
		['questions', 'Workspace Website Analysis Buyer Questions'],
		['qualifying-questions', 'Workspace Website Analysis Qualifying Questions'],
		['objections', 'Workspace Website Analysis Objections'],
		['topics', 'Workspace Website Analysis Key Topics'],
	].map(([icpTab, name]) => ({
		path: icpTabPaths[icpTab],
		name,
		component: () => import('@/views/account/AccountView.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'workspace-settings']],
			nav: 'workspace',
			settingsTab: 'icp-analysis',
			icpTab,
		},
	})),
	{
		path: '/workspace/settings/pixel',
		name: 'Workspace Settings Add Pixel',
		component: () => import('@/views/account/AccountAddPixel.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'workspace-settings']],
			nav: 'workspace',
		}
	},
	{
		path: '/workspace/settings/add',
		name: 'Workspace Settings Add Workspace',
		component: () => import('@/views/account/AccountAddWorkspace.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'workspace-settings']],
			nav: 'workspace',
		}
	},
]